/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weak_Gold_Hare_BurnInputs */

const en_weak_gold_hare_burn = /** @type {(inputs: Weak_Gold_Hare_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This can take some time...`)
};

const de_weak_gold_hare_burn = /** @type {(inputs: Weak_Gold_Hare_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das kann einige Sekunden dauern...`)
};

/**
* | output |
* | --- |
* | "This can take some time..." |
*
* @param {Weak_Gold_Hare_BurnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const weak_gold_hare_burn = /** @type {((inputs?: Weak_Gold_Hare_BurnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weak_Gold_Hare_BurnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weak_gold_hare_burn(inputs)
	return de_weak_gold_hare_burn(inputs)
});